(() => {
  const initialize = () => {
    document.querySelectorAll('.hk-recipe-market').forEach((section) => {
      if (section.dataset.hkBasketReady === 'true') return;
      const checks = Array.from(section.querySelectorAll('.hk-recipe-market-check'));
      const singleButtons = Array.from(section.querySelectorAll('.hk-recipe-market-buy button[name="add"]'));
      const button = section.querySelector('[data-recipe-add]');
      const includeExisting = section.querySelector('[data-recipe-add-existing]');
      const count = section.querySelector('[data-recipe-count]');
      const total = section.querySelector('[data-recipe-total]');
      const totalLabel = section.querySelector('[data-recipe-total-label]');
      const existing = section.querySelector('[data-recipe-existing]');
      const status = section.querySelector('[data-recipe-status]');
      const error = section.querySelector('[data-recipe-error]');
      const cartHint = section.querySelector('[data-recipe-cart-hint]');
      if (!button || !includeExisting || !count || !total || !totalLabel || !existing || !status || !error || !cartHint) return;
      section.dataset.hkBasketReady = 'true';
      const currency = section.dataset.currency || 'EUR';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style: 'currency', currency});
      const root = window.Shopify?.routes?.root || '/';
      let busy = false;
      let requiresReview = false;
      let navigating = false;
      let cartRefreshToken = 0;
      let lastKnownCart = null;
      const selected = () => checks.filter((node) => node.checked);
      const clearMessages = () => { error.hidden = true; status.hidden = true; existing.hidden = true; };
      const showError = (message) => { error.textContent = message; error.hidden = false; };
      const showStatus = (message) => { status.textContent = message; status.hidden = false; };
      const render = () => {
        const chosen = selected();
        count.textContent = String(chosen.length);
        const existingSelection = lastKnownCart ? chosen.filter((node) => (lastKnownCart.get(node.value) || 0) > 0).length : 0;
        cartHint.hidden = existingSelection === 0;
        cartHint.textContent = existingSelection ? String(existingSelection) + ' van je geselecteerde producten staan al in de winkelwagen. Ze worden standaard niet opnieuw toegevoegd.' : '';
        checks.forEach((node) => {
          const badge = node.closest('.hk-recipe-market-card')?.querySelector('[data-recipe-in-cart]');
          if (!badge) return;
          const qty = lastKnownCart?.get(node.value) || 0;
          badge.hidden = qty === 0;
          badge.textContent = qty > 0 ? 'Al in winkelwagen (' + String(qty) + ')' : '';
        });
        if (currency === 'EUR') {
          total.textContent = formatter.format(chosen.reduce((sum, node) => sum + (Number(node.dataset.price) || 0), 0) / 100);
          totalLabel.textContent = 'indicatieve productwaarde';
        } else {
          total.textContent = '—';
          totalLabel.textContent = 'actuele prijs in je winkelwagen';
        }
        const sharedBusy = window.HK360RecipeCart?.isBusy?.() === true || window.HK360RecipeCart?.isBlocked?.() === true;
        button.disabled = busy || sharedBusy || requiresReview || navigating || chosen.length === 0;
        checks.forEach((node) => { node.disabled = busy || sharedBusy || requiresReview || navigating; });
        includeExisting.disabled = busy || sharedBusy || requiresReview || navigating;
        singleButtons.forEach((node) => {
          const form = node.closest('form');
          node.disabled = busy || sharedBusy || requiresReview || navigating || form?.dataset.hk189Busy === 'true' || form?.dataset.hk189Review === 'true';
        });
      };
      const readCart = async () => {
        let response;
        try {
          response = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
        } catch (_) { throw new Error('Je winkelwagen kan niet worden gecontroleerd. Probeer het opnieuw.'); }
        if (!response.ok) throw new Error('Je winkelwagen kan niet worden gecontroleerd. Probeer het opnieuw.');
        const cart = await response.json();
        if (!cart || !Array.isArray(cart.items)) throw new Error('Je winkelwagen is niet goed geladen. Probeer het opnieuw.');
        const quantities = new Map();
        cart.items.forEach((item) => {
          const id = String(item.variant_id);
          const quantity = Number(item.quantity);
          if (!/^\d+$/.test(id) || !Number.isSafeInteger(Number(id)) || !Number.isSafeInteger(quantity) || quantity < 0) throw new Error('Je winkelwagen is niet goed geladen. Probeer het opnieuw.');
          quantities.set(id, (quantities.get(id) || 0) + quantity);
        });
        return quantities;
      };
      const refreshCart = async () => {
        const token = ++cartRefreshToken;
        try {
          const qty = await readCart();
          if (token !== cartRefreshToken || busy || requiresReview || navigating) return;
          lastKnownCart = qty;
          render();
        } catch (_) {
          if (token !== cartRefreshToken || busy || requiresReview || navigating) return;
          lastKnownCart = null;
          render();
        }
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
      }
      if (typeof window.addEventListener === 'function') {
        window.addEventListener('pageshow', (event) => { if (event.persisted) refreshCart(); });
        window.addEventListener('hk360:cart-changed', () => { if (!busy) refreshCart(); });
        window.addEventListener('hk360:recipe-write', () => {
          render();
          if (!busy && !window.HK360RecipeCart?.isBusy?.()) refreshCart();
        });
      }
      checks.forEach((node) => node.addEventListener('change', () => { clearMessages(); render(); }));
      includeExisting.addEventListener('change', () => { clearMessages(); render(); });
      button.addEventListener('click', async () => {
        if (busy || requiresReview || navigating) return;
        const ids = [...new Set(selected().map((node) => node.value))];
        if (!ids.length) return;
        if (ids.some((value) => !/^\d+$/.test(value) || !Number.isSafeInteger(Number(value)) || Number(value) <= 0)) {
          showError('Sommige producten kunnen niet worden toegevoegd. Open de productpagina.');
          return;
        }
        if (!window.HK360RecipeCart?.acquire?.('bulk')) {
          showError(window.HK360RecipeCart?.isBlocked?.()
            ? 'Een eerdere toevoeging is niet bevestigd. Controleer je winkelwagen voordat je opnieuw probeert.'
            : 'Er wordt al iets toegevoegd. Wacht tot de winkelwagen is bijgewerkt.');
          return;
        }
        busy = true;
        cartRefreshToken += 1;
        clearMessages();
        render();
        button.textContent = 'Winkelwagen controleren…';
        try {
          const before = await readCart();
          lastKnownCart = before;
          render();
          const repeats = ids.filter((id) => (before.get(id) || 0) > 0);
          const toAdd = includeExisting.checked ? ids : ids.filter((id) => !repeats.includes(id));
          if (repeats.length && !includeExisting.checked) {
            existing.textContent = String(repeats.length) + ' product(en) al in je winkelwagen: niet opnieuw toegevoegd.';
            existing.hidden = false;
          }
          if (!toAdd.length) {
            showStatus('Alle geselecteerde producten staan al in je winkelwagen. Bekijk je winkelwagen om aantallen te controleren.');
            return;
          }
          button.textContent = 'Toevoegen…';
          let addResponse = null;
          try {
            addResponse = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json', Accept: 'application/json'},
              credentials: 'same-origin',
              body: JSON.stringify({items: toAdd.map((value) => ({id: Number(value), quantity: 1}))})
            });
          } catch (_) {}
          if (addResponse?.ok) {
            try {
              const after = await readCart();
              lastKnownCart = after;
              const addedCount = toAdd.reduce((sum, variantId) =>
                sum + Math.min(1, Math.max(0, (after.get(variantId) || 0) - (before.get(variantId) || 0))), 0);
              if (addedCount === toAdd.length) {
                showStatus(String(addedCount) + ' product(en) toegevoegd. Je kunt gewoon verder lezen en je winkelwagen later controleren.');
              } else {
                requiresReview = true;
                if (addedCount > 0) showStatus(String(addedCount) + ' product(en) toegevoegd.');
                showError('Niet alle aantallen konden worden bevestigd. Controleer je winkelwagen voordat je opnieuw probeert.');
              }
              const itemCount = [...after.values()].reduce((sum, quantity) => sum + quantity, 0);
              window.HK360RecipeCart?.notify?.({ item_count: itemCount });
            } catch (_) {
              requiresReview = true;
              showStatus('Shopify heeft het toevoegen bevestigd. Controleer de aantallen in je winkelwagen.');
            }
            return;
          }
          requiresReview = true;
          let addError = '';
          if (addResponse) {
            try { const details = await addResponse.json(); addError = typeof details.description === 'string' ? details.description : ''; } catch (_) {}
          }
          try {
            const after = await readCart();
            lastKnownCart = after;
            render();
            const addedCount = toAdd.reduce((sum, variantId) =>
              sum + Math.min(1, Math.max(0, (after.get(variantId) || 0) - (before.get(variantId) || 0))), 0);
            if (addResponse && [400, 422].includes(addResponse.status) && addedCount === 0) {
              requiresReview = false;
            }
            if (addedCount > 0) showStatus(String(addedCount) + ' van ' + String(toAdd.length) + ' geselecteerde producten is/zijn toegevoegd. Bekijk je winkelwagen voordat je opnieuw probeert.');
            if (addedCount < toAdd.length) showError(addError || 'Niet alle producten zijn toegevoegd. Beschikbaarheid kan intussen zijn gewijzigd.');
            if (addedCount === 0 && !addError) showError('Toevoegen niet bevestigd. Controleer eerst je winkelwagen voordat je opnieuw probeert.');
          } catch (_) { showError('De verwerking kon niet worden bevestigd. Controleer eerst je winkelwagen voordat je opnieuw probeert.'); }
        } catch (problem) { showError(problem?.message || 'Je winkelwagen kon niet worden gecontroleerd. Probeer het opnieuw.'); }
        finally {
          busy = false;
          button.textContent = requiresReview ? 'Controleer eerst je winkelwagen' : 'Voeg geselecteerde producten toe';
          if (requiresReview) window.HK360RecipeCart?.flagReview?.();
          window.HK360RecipeCart?.release?.('bulk');
          render();
        }
      });
      render();
      refreshCart();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();